import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes, type SelectHTMLAttributes, type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const base =
  'w-full rounded-md border border-input bg-card px-2.5 text-sm shadow-xs outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-destructive';

/** Ô số (NumberInput) trong hộp thoại: cùng khung với Input; `required` = ô bắt buộc, nền nhấn nhẹ để NV thấy ngay ô cần nhập. */
export const fieldClass = (required = false) => cn(base, 'h-9', required && 'border-primary/60 bg-primary/5');

/** Ô số trên màn điện thoại (tài xế, phụ xe): có khung rõ, cao 44px cho ngón tay, chữ 16px để iOS không tự phóng to. */
export const phoneField = cn(base, 'h-11 border-foreground/30 text-base');

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(base, 'h-9', className)} {...props} />
));
Input.displayName = 'Input';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(({ className, ...props }, ref) => (
  <textarea ref={ref} className={cn(base, 'min-h-16 py-2', className)} {...props} />
));
Textarea.displayName = 'Textarea';

/** Select gốc của trình duyệt: thao tác bàn phím nhanh nhất (gõ chữ cái để nhảy). */
export const NativeSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(({ className, ...props }, ref) => (
  <select ref={ref} className={cn(base, 'h-9 pr-7', className)} {...props} />
));
NativeSelect.displayName = 'NativeSelect';

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return <label className={cn('mb-1 block text-xs font-medium text-muted-foreground', className)} {...props} />;
}
